/* GENERATED from the article prototype script: heading ids, the contents list and table wrappers, built in the browser from the article body. */
(function () {
  'use strict';
  var prose = document.querySelector('[data-jr-prose]');
  if (!prose) return;
  var slug = function (s) { return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'section'; };

  /* headings: every h2 and h3 gets an id (text from a CMS may not have them), and the contents follow the reader */
  var used = {};
  [].slice.call(document.querySelectorAll('[id]')).forEach(function (e) { used[e.id] = 1; });
  var heads = [].slice.call(prose.querySelectorAll('h2, h3'));
  heads.forEach(function (h) {
    if (h.id) return;
    var b = slug(h.textContent), id = b, n = 2;
    while (used[id]) id = b + '-' + n++;
    h.id = id; used[id] = 1;
  });
  var h2s = heads.filter(function (h) { return h.tagName === 'H2'; });
  var toc = document.querySelector('[data-jr-toc]'), tocm = document.querySelector('[data-jr-tocm]');
  function makeList() {
    var ol = document.createElement('ol');
    h2s.forEach(function (h) {
      var li = document.createElement('li'), a = document.createElement('a');
      a.className = 'jr-toc__a'; a.setAttribute('href', '#' + h.id); a.textContent = h.textContent;
      li.appendChild(a); ol.appendChild(li);
    });
    return ol;
  }
  if (!toc && h2s.length > 2) {
    /* no list in the markup: build the side list and the small-screen list (the Shopify case, where the text is one block of HTML) */
    var layout = document.querySelector('.jr-layout'), art = document.querySelector('.jr-art');
    if (layout && art) {
      var nav = document.createElement('nav'), hd = document.createElement('p');
      nav.className = 'jr-toc'; nav.setAttribute('aria-label', 'On this page'); nav.setAttribute('data-jr-toc', '');
      hd.className = 'jr-toc__h'; hd.textContent = 'On this page';
      nav.appendChild(hd); nav.appendChild(makeList()); layout.insertBefore(nav, art); toc = nav;
      layout.classList.remove('jr-notoc');
      var d = document.createElement('details'), sm = document.createElement('summary'), n2 = document.createElement('nav');
      d.className = 'jr-tocm'; d.setAttribute('data-jr-tocm', ''); sm.textContent = 'On this page';
      n2.setAttribute('aria-label', 'On this page, short list'); n2.appendChild(makeList()); d.appendChild(sm); d.appendChild(n2);
      prose.parentNode.insertBefore(d, prose); tocm = d;
    }
  }
  var links = [].slice.call(document.querySelectorAll('.jr-toc__a'));
  function mark(id) {
    links.forEach(function (a) { if (a.getAttribute('href') === '#' + id) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current'); });
  }
  if (h2s.length && links.length) {
    mark(h2s[0].id);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) mark(e.target.id); }); }, { rootMargin: '-12% 0px -75% 0px' });
      h2s.forEach(function (h) { io.observe(h); });
    }
  }
  /* the small-screen contents start closed and close again after a choice; on desktop the sticky list is used */
  if (tocm) {
    if (window.matchMedia && window.matchMedia('(max-width: 899px)').matches) tocm.open = false;
    tocm.addEventListener('click', function (e) { if (e.target.closest('a')) tocm.open = false; });
  }

  /* tables: a bare table gets the scroll wrapper; a wrapper that really scrolls becomes reachable by keyboard */
  [].slice.call(prose.querySelectorAll('table')).forEach(function (t) {
    if (!t.parentElement.classList.contains('w-table-wrap')) {
      var w = document.createElement('div'); w.className = 'w-table-wrap';
      t.parentNode.insertBefore(w, t); w.appendChild(t);
      if (!t.classList.contains('w-table')) t.classList.add('w-table');
    }
  });
  function scrollers() {
    [].slice.call(prose.querySelectorAll('.w-table-wrap')).forEach(function (w) {
      var cap = w.querySelector('caption');
      if (w.scrollWidth > w.clientWidth + 1) { w.tabIndex = 0; w.setAttribute('role', 'region'); w.setAttribute('aria-label', (cap ? cap.textContent : 'Table') + ' (scrolls sideways)'); }
      else { w.removeAttribute('tabindex'); w.removeAttribute('role'); w.removeAttribute('aria-label'); }
    });
  }
  scrollers(); window.addEventListener('resize', scrollers);
})();;
(function () {
  'use strict';
  [].slice.call(document.querySelectorAll('[data-cmp]')).forEach(function (box) {
    var table = box.querySelector('table');
    if (!table || !table.tBodies.length || !table.tHead) return;
    var tbody = table.tBodies[0], rows = [].slice.call(tbody.rows);
    var ctl = box.querySelector('[data-cmp-ctl]');
    if (ctl) ctl.hidden = false;
    var live = document.createElement('p');
    live.className = 'w-sr'; live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite');
    box.appendChild(live);
    var key = null, dir = 0;
    function rank(tr) { var c = tr.querySelector('[data-col="' + key + '"]'); return c ? +c.getAttribute('data-rank') : -1; }
    function order() {
      var list = rows.slice();
      if (key && dir) list.sort(function (a, b) { var d = rank(b) - rank(a); if (dir === 2) d = -d; return d || (+a.getAttribute('data-i') - +b.getAttribute('data-i')); });
      list.forEach(function (tr) { tbody.appendChild(tr); });
      [].slice.call(table.tHead.rows[0].cells).forEach(function (th) {
        var k = th.getAttribute('data-col');
        if (k) th.setAttribute('aria-sort', k === key && dir ? (dir === 1 ? 'descending' : 'ascending') : 'none');
      });
    }
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cmp-sort]');
      if (!b || !box.contains(b)) return;
      var k = b.getAttribute('data-cmp-sort');
      if (k === key) dir = (dir + 1) % 3; else { key = k; dir = 1; }
      order();
      var name = b.textContent.replace(/\s+/g, ' ').trim();
      live.textContent = dir ? 'Rows sorted by ' + name + (dir === 1 ? ', strongest first.' : ', weakest first.') : 'Rows back in the original order.';
    });
    box.addEventListener('change', function (e) {
      var t = e.target, g = t.getAttribute('data-cmp-group'), c = t.getAttribute('data-cmp-col');
      if (g !== null) rows.forEach(function (tr) { if (tr.getAttribute('data-group') === g) tr.hidden = !t.checked; });
      if (c !== null) [].slice.call(table.querySelectorAll('[data-col="' + c + '"]')).forEach(function (x) { x.hidden = !t.checked; });
      var shown = rows.filter(function (tr) { return !tr.hidden; }).length;
      live.textContent = shown + ' of ' + rows.length + ' criteria shown.';
      try { window.dispatchEvent(new Event('resize')); } catch (x) { /* old browsers */ }
    });
  });
})();
